import { defineMessages } from "@formatjs/intl";
export default defineMessages({
  allSubjectsMenuItem: {
    id: "questionbank.listfilter.allSubjectsMenuItem",
    defaultMessage: "All Subjects"
  },
  allCoursesMenuItem: {
    id: "questionbank.listfilter.allCoursesMenuItem",
    defaultMessage: "All Courses"
  },
  allTypesMenuItem: {
    id: "questionbank.listfilter.allTypesMenuItem",
    defaultMessage: "All Types"
  },
  allDifficultiesMenuItem: {
    id: "questionbank.listfilter.allDifficultiesMenuItem",
    defaultMessage: "All Difficulties"
  },
  allStatesMenuItem: {
    id: "questionbank.listfilter.allStatesMenuItem",
    defaultMessage: "All States"
  },
  searchPlaceholder: {
    id: "questionbank.listfilter.searchPlaceholder",
    defaultMessage: "Search"
  },
  tagsPlaceholder: {
    id: "questionbank.listfilter.tagsPlaceholder",
    defaultMessage: "Tags"
  },
  easyDifficultyID: {
    id: "questionbank.listfilter.easyDifficultyID",
    defaultMessage: "Easy"
  },
  mediumDifficultyID: {
    id: "questionbank.listfilter.mediumDifficultyID",
    defaultMessage: "Medium"
  },
  HardDifficultyID: {
    id: "questionbank.listfilter.HardDifficultyID",
    defaultMessage: "Hard"
  },
  essayTypeID: {
    id: "questionbank.listfilter.essayTypeID",
    defaultMessage: "Essay"
  },
  fibTypeID: {
    id: "questionbank.listfilter.fibTypeID",
    defaultMessage: "FIB"
  },
  tfTypeID: {
    id: "questionbank.listfilter.tfTypeID",
    defaultMessage: "TF"
  },
  mcqTypeID: {
    id: "questionbank.listfilter.mcqTypeID",
    defaultMessage: "MCQ"
  },
  orderingTypeID: {
    id: "questionbank.listfilter.orderingTypeID",
    defaultMessage: "Ordering"
  },
  matchingTypeID: {
    id: "questionbank.listfilter.matchingTypeID",
    defaultMessage: "Matching"
  },
  questionsTypography: {
    id: "questionbank.listfilter.questionsTypography",
    defaultMessage: "Questions"
  },
  listAvailableTypography: {
    id: "questionbank.listfilter.listAvailableTypography",
    defaultMessage: "List of your all available questions"
  },
  selectMenuItem: {
    id: "questionbank.listfilter.selectMenuItem",
    defaultMessage: "Select"
  }
});